import React, { useState } from 'react';
import { withRouter } from 'react-router-dom'
import fire from '../../config/Fire';

export const NavBar = (props) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const LogoutLink = withRouter(({ history }) => (
    <a className="nav-link" href="/logout" onClick={(e) => {
      e.preventDefault()
      fire.auth().signOut()
      history.replace('/')
    }}>
      Logout
  </a>
  ))

  const exportLink = (props.userId === null) ? null : <a className="nav-link" href="/export">Export Data</a>
  const sessionLink = (props.userId === null) ? <a className="nav-link" href="/login">Organization Log In</a> : <LogoutLink />

  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
        <div className="container">
          <a className="navbar-brand" href="/">Tree Tracker App</a>
          <button className="navbar-toggler" type="button" onClick={() => setIsCollapsed(!isCollapsed)}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={isCollapsed ? "navbar-collapse collapse" : "navbar-collapse collapse show"} id="navbarResponsive" style={{}}>
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                {exportLink}
              </li>
              <li className="nav-item">
                {sessionLink}
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  )
}





// WEBPACK FOOTER //
// ./src/components/nav-bar/NavBar.js